import { render, staticRenderFns } from "./my-order.vue?vue&type=template&id=c9cdec0e&scoped=true"
import script from "./my-order.vue?vue&type=script&lang=ts"
export * from "./my-order.vue?vue&type=script&lang=ts"
import style0 from "./my-order.vue?vue&type=style&index=0&id=c9cdec0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9cdec0e",
  null
  
)

export default component.exports